module.exports = (__webpack_require__(12))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/pluginUtils.js from dll-reference girder_plugin_large_image
// module id = 126
// module chunks = 0